import React from 'react';
import styled, { useTheme } from 'styled-components';

// Tipos
type BotaoTipo = 'delete' | 'save' | 'cancel' | 'export';
type BotaoTamanho = 'sm' | 'md' | 'lg';

interface BotaoEstiloProps {
  $cor: string; // Prefixo $ para styled-components
  $tamanho: BotaoTamanho;
}

// Estilo do botão
const BotaoEstilizado = styled.button<BotaoEstiloProps>`
  border-radius: 10px;
  min-width: ${({ $tamanho }) =>
    $tamanho === 'sm' ? '90px' : $tamanho === 'lg' ? '120px' : '100px'};
  padding: ${({ $tamanho }) =>
    $tamanho === 'sm'
      ? '6px 10px'
      : $tamanho === 'lg'
        ? '10px 16px'
        : '8px 12px'};
  font:
    normal normal normal 1rem/1.25rem 'Rawline',
    sans-serif;
  background-color: ${({ $cor }) => $cor};
  color: white;
  border: 1px solid ${({ $cor }) => $cor};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  font-size: ${({ $tamanho }) =>
    $tamanho === 'sm' ? '0.875rem' : $tamanho === 'lg' ? '1.125rem' : '1rem'};

  &:hover {
    transform: scale(1.03);
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    filter: grayscale(50%);
    transform: none !important;
  }

  .icone {
    display: flex;
    align-items: center;
    font-size: ${({ $tamanho }) =>
      $tamanho === 'sm' ? '1rem' : $tamanho === 'lg' ? '1.3rem' : '1.1rem'};
  }
`;

interface WorkspaceBotoesProps {
  tipo: BotaoTipo;
  onClick: () => void;
  disabled?: boolean;
  label?: string;
  cor?: string;
  tamanho?: BotaoTamanho;
  icone?: React.ReactNode;
  style?: React.CSSProperties;
}

const WorkspaceBotoesNew: React.FC<WorkspaceBotoesProps> = ({
  tipo,
  onClick,
  disabled = false,
  label,
  cor,
  tamanho = 'md',
  icone,
  style,
}) => {
  const theme = useTheme();

  // Mapeamento de tipos para cores padrão
  const coresPadrao = {
    delete: theme.colors.workspace?.botaoVermelho || '#e74c3c',
    save: theme.colors.azulgov || '#3498db',
    cancel: theme.colors.botaoLaranja || '#f39c12',
    export: theme.colors.verdegov || '#2ecc71',
  };

  // Textos padrão
  const textosPadrao = {
    delete: 'Deletar',
    save: 'Salvar',
    cancel: 'Cancelar',
    export: 'Exportar',
  };

  return (
    <BotaoEstilizado
      $cor={cor || coresPadrao[tipo]}
      $tamanho={tamanho}
      onClick={onClick}
      disabled={disabled}
      aria-label={label || textosPadrao[tipo]}
      style={style}
    >
      {icone && <span className="icone">{icone}</span>}
      {label || textosPadrao[tipo]}
    </BotaoEstilizado>
  );
};

export default WorkspaceBotoesNew;
